import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_3M_66_65_3M_25_99',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_3m_66_65_3m_25_99_usd',
			ARS: 'simple_premium_3m_75900_3m_29900_ars',
			AUD: 'simple_premium_3m_99_99_3m_39_99_aud',
			BRL: 'simple_premium_3m_379_3m_146_99_brl',
			CAD: 'simple_premium_3m_89_99_3m_35_99_cad',
			CLP: 'simple_premium_3m_62900_3m_24900_clp',
			COP: 'simple_premium_3m_276900_3m_107900_cop',
			DKK: 'simple_premium_3m_439_3m_169_dkk',
			EUR: 'simple_premium_3m_66_65_3m_25_99_eur',
			GBP: 'simple_premium_3m_66_65_3m_25_99_gbp',
			MXN: 'simple_premium_3m_1279_3m_499_mxn',
			NOK: 'simple_premium_3m_669_3m_259_nok',
			PLN: 'simple_premium_3m_249_3m_96_99_pln',
			SEK: 'simple_premium_3m_639_3m_249_sek',
			TRY: 'simple_premium_3m_2900_3m_999_try',
		},
		primer: 'prd_l6XLcXv1v22e',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 3,
		intro_period_type: 'month',
		next_period_value: 3,
		next_period_type: 'month',
	},
	trial: {
		days: 90,
		priceMap: {
			USD: 25.99,
			ARS: 29900,
			AUD: 39.99,
			BRL: 146.99,
			CAD: 35.99,
			CLP: 24900,
			COP: 107900,
			DKK: 169,
			EUR: 25.99,
			GBP: 25.99,
			MXN: 499,
			NOK: 259,
			PLN: 96.99,
			SEK: 249,
			TRY: 999,
		},
		originalPriceMap: {
			USD: 66.65,
			ARS: 75900,
			AUD: 99.99,
			BRL: 379,
			CAD: 89.99,
			CLP: 62900,
			COP: 276900,
			DKK: 439,
			EUR: 66.65,
			GBP: 66.65,
			MXN: 1279,
			NOK: 669,
			PLN: 249,
			SEK: 639,
			TRY: 2900,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 66.65,
			ARS: 75900,
			AUD: 99.99,
			BRL: 379,
			CAD: 89.99,
			CLP: 62900,
			COP: 276900,
			DKK: 439,
			EUR: 66.65,
			GBP: 66.65,
			MXN: 1279,
			NOK: 669,
			PLN: 249,
			SEK: 639,
			TRY: 2900,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('female_yoga.pages.paywall.plans.12_weeks.into_period_text'), // first three months
		explicitTermsIntervalText: $t('female_yoga.pages.paywall.plans.12_weeks.period_text'), // 3 months
		billingSubtitlePeriodText: $t('female_yoga.pages.paywall.plans.12_weeks.billing_period_text'), // 'three months'
		footerPeriodText: $t('female_yoga.pages.paywall.plans.12_weeks.footer_period_text'), // '3-month'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.90_days.sub_period_text'), // '3-month'
		updatedTermsPeriodText: $t('female_yoga.pages.paywall.plans.12_weeks.terms_period_text'), // 'first 3 months'
	}),
}
